<div class="card">

  <h5 class="page-title">Delivery Partners</h5>

  <div *ngIf="featureDisabled" class="feature-disabled">
    TinyAll Delivery Network is not enabled on this environment
    (set <code>TINYALL_DELIVERY_NETWORK_ENABLED=true</code> on the backend).
  </div>

  <div *ngIf="!featureDisabled" class="workflow-banner">
    <strong>Courier linking workflow</strong>
    <ol>
      <li>Create partner (starts as PENDING / APPLICANT).</li>
      <li>Issue a one-time device token and give it to the courier.</li>
      <li>Courier enters the token in the TinyAll Courier app.</li>
      <li>Search by name, email, or phone. Sort and filter any column. The list includes every courier, not only the newest page.</li>
      <li>Open <em>Revisar solicitud</em> to approve onboarding, or use Approve for full network access.</li>
      <li>Hub owner pairs APPROVED or SHORTLISTED couriers under Hub Settings → Delivery Network.</li>
    </ol>
  </div>

  <div class="toolbar">
    <label class="search-field">
      Search
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="search" [(ngModel)]="search" (ngModelChange)="applyView()"
               placeholder="Name, email, or phone" />
      </span>
    </label>
    <label>
      Status
      <select [(ngModel)]="statusFilter" (ngModelChange)="applyView()">
        <option *ngFor="let s of statusOptions" [value]="s">{{ s || 'All' }}</option>
      </select>
    </label>
    <label>
      Onboarding
      <select [(ngModel)]="onboardingFilter" (ngModelChange)="applyView()">
        <option *ngFor="let option of onboardingOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </label>
    <label>
      Access
      <select [(ngModel)]="accessFilter" (ngModelChange)="applyView()">
        <option *ngFor="let option of accessOptions" [value]="option.value">{{ option.label }}</option>
      </select>
    </label>
    <button pButton type="button" icon="pi pi-filter-slash" label="Clear"
            class="p-button-sm p-button-text" (click)="clearListFilters()"></button>
    <button pButton type="button" icon="pi pi-plus" label="New Partner"
            class="p-button-sm" (click)="openCreateDialog()"></button>
    <button pButton type="button" icon="pi pi-refresh" label="Refresh"
            class="p-button-sm p-button-secondary" (click)="loadData()"></button>
  </div>
  <p class="list-count" *ngIf="!isLoading">
    Showing {{ data.length }} of {{ allPartners.length }} couriers.
    <span *ngIf="listTruncated"> The list stopped after {{ allPartners.length }} records.</span>
  </p>

  <p-table
    #partnersTable
    [value]="data"
    dataKey="id"
    [rows]="30"
    [paginator]="true"
    [rowsPerPageOptions]="pageSizeOptions"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    sortField="createdOn"
    [sortOrder]="-1"
    [loading]="isLoading"
    styleClass="p-datatable-customers p-datatable-gridlines"
    [autoLayout]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="listName">
          <div class="p-d-flex p-jc-between p-ai-center">
            Name
            <p-sortIcon field="listName"></p-sortIcon>
            <p-columnFilter type="text" field="listName" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="phone">
          <div class="p-d-flex p-jc-between p-ai-center">
            Phone
            <p-sortIcon field="phone"></p-sortIcon>
            <p-columnFilter type="text" field="phone" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="listEmail">
          <div class="p-d-flex p-jc-between p-ai-center">
            Email
            <p-sortIcon field="listEmail"></p-sortIcon>
            <p-columnFilter type="text" field="listEmail" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="status">
          <div class="p-d-flex p-jc-between p-ai-center">
            Status
            <p-sortIcon field="status"></p-sortIcon>
            <p-columnFilter field="status" matchMode="equals" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" [options]="statusColumnOptions" (onChange)="filter($event.value)" placeholder="Any"></p-dropdown>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="onboardingLabelText">
          <div class="p-d-flex p-jc-between p-ai-center">
            Onboarding
            <p-sortIcon field="onboardingLabelText"></p-sortIcon>
            <p-columnFilter field="onboardingLabelText" matchMode="equals" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" [options]="onboardingColumnOptions" (onChange)="filter($event.value)" placeholder="Any"></p-dropdown>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="accessLabel">
          <div class="p-d-flex p-jc-between p-ai-center">
            Access
            <p-sortIcon field="accessLabel"></p-sortIcon>
            <p-columnFilter field="accessLabel" matchMode="equals" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" [options]="accessColumnOptions" (onChange)="filter($event.value)" placeholder="Any"></p-dropdown>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="platformLevel">
          <div class="p-d-flex p-jc-between p-ai-center">
            Level
            <p-sortIcon field="platformLevel"></p-sortIcon>
            <p-columnFilter type="numeric" field="platformLevel" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="ratingValue">
          <div class="p-d-flex p-jc-between p-ai-center">
            Rating
            <p-sortIcon field="ratingValue"></p-sortIcon>
            <p-columnFilter type="numeric" field="ratingValue" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="completedDeliveries">
          <div class="p-d-flex p-jc-between p-ai-center">
            Completed
            <p-sortIcon field="completedDeliveries"></p-sortIcon>
            <p-columnFilter type="numeric" field="completedDeliveries" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="incidentCount">
          <div class="p-d-flex p-jc-between p-ai-center">
            Incidents
            <p-sortIcon field="incidentCount"></p-sortIcon>
            <p-columnFilter type="numeric" field="incidentCount" display="menu" [maxConstraints]="1" [showOperator]="false" class="p-ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="createdOn">
          <div class="p-d-flex p-jc-between p-ai-center">
            Created
            <p-sortIcon field="createdOn"></p-sortIcon>
          </div>
        </th>
        <th class="actions-col">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <span class="courier-identity">
            <img *ngIf="item.photoUrl" class="courier-identity__photo" [src]="item.photoUrl" alt=""
                 loading="lazy" (error)="item.photoUrl = null" />
            <span *ngIf="!item.photoUrl" class="courier-identity__placeholder" aria-hidden="true"></span>
            <span>{{ item.listName }}</span>
          </span>
        </td>
        <td>{{ item.phone }}</td>
        <td>{{ item.listEmail || '—' }}</td>
        <td><span class="status-tag" [ngClass]="statusSeverity(item.status)">{{ item.status }}</span></td>
        <td>{{ item.onboardingLabelText }}</td>
        <td><span class="status-tag" [ngClass]="accessSeverity(item.accessLabel || '')">{{ item.accessLabel }}</span></td>
        <td>{{ item.platformLevel }}</td>
        <td>{{ formatAverageRating(item.ratingValue) }}</td>
        <td>{{ item.completedDeliveries || 0 }}</td>
        <td>{{ item.incidentCount || 0 }}</td>
        <td>{{ item.createdOn ? (item.createdOn | date:'mediumDate') : '—' }}</td>
        <td class="actions-col">
          <button pButton type="button" [label]="approveButtonLabel(item)" class="p-button-sm p-button-success p-mr-1"
                  *ngIf="item.status !== 'APPROVED'"
                  (click)="confirmApproveFromList(item)"></button>
          <button pButton type="button" label="Shortlist" class="p-button-sm p-button-info p-mr-1"
                  *ngIf="item.status !== 'SHORTLISTED' && item.status !== 'REJECTED' && item.status !== 'DEACTIVATED'"
                  (click)="confirmShortlist(item)"></button>
          <button pButton type="button" label="Suspend" class="p-button-sm p-button-warning p-mr-1"
                  *ngIf="item.status !== 'SUSPENDED'"
                  (click)="confirmSetStatus(item, 'SUSPENDED')"></button>
          <button pButton type="button" label="Reject" class="p-button-sm p-button-danger p-mr-1"
                  *ngIf="item.status !== 'REJECTED'"
                  (click)="confirmSetStatus(item, 'REJECTED')"></button>
          <button pButton type="button" label="Volver a solicitante" class="p-button-sm p-button-outlined p-mr-1"
                  *ngIf="item.status === 'REJECTED'"
                  (click)="openApplicantReturn(item)"></button>
          <button pButton type="button" label="Reviews" class="p-button-sm p-button-outlined p-mr-1"
                  (click)="viewReviews(item)"></button>
          <button pButton type="button" label="Revisar solicitud" class="p-button-sm p-button-outlined p-mr-1"
                  (click)="viewOnboarding(item)"></button>
          <button pButton type="button" label="Reset QA courier" class="p-button-sm p-button-outlined p-button-danger p-mr-1"
                  *ngIf="item.qaResetEligible"
                  (click)="confirmQaReset(item)"></button>
          <button pButton type="button" label="Token" class="p-button-sm p-button-secondary"
                  (click)="issueToken(item)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="12">{{ search.trim() || statusFilter || onboardingFilter || accessFilter ? 'No couriers matched those filters.' : 'No delivery partners found.' }}</td></tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="New Delivery Partner" [(visible)]="createDialogVisible" [modal]="true"
          [style]="{ width: '440px' }">
  <div class="form-grid">
    <label>Display name<input type="text" [(ngModel)]="newPartner.displayName" /></label>
    <label>Phone<input type="text" [(ngModel)]="newPartner.phone" /></label>
    <label>Email (optional)<input type="email" [(ngModel)]="newPartner.email" /></label>
    <label>Base rate (first km)<input type="number" [(ngModel)]="newPartner.rateMinPrice" /></label>
    <label>Rate per additional km<input type="number" [(ngModel)]="newPartner.ratePerAdditionalKm" /></label>
    <label>Cash capacity<input type="number" [(ngModel)]="newPartner.cashCapacityAmount" /></label>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" class="p-button-text"
            (click)="createDialogVisible = false"></button>
    <button pButton type="button" label="Create" [disabled]="isSaving"
            (click)="saveNewPartner()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Delivery Partner Token" [(visible)]="tokenDialogVisible" [modal]="true"
          [style]="{ width: '480px' }">
  <p>Token for <strong>{{ issuedTokenPartnerName }}</strong>. Copy it now — it is shown only once.</p>
  <textarea readonly rows="3" class="token-box">{{ issuedToken }}</textarea>
  <p class="token-hint">Courier app: enter this token once. Header for API tests: <code>Authorization: DeliveryPartner &lt;token&gt;</code></p>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Close" (click)="tokenDialogVisible = false"></button>
  </ng-template>
</p-dialog>

<p-dialog
  [header]="'Revisar solicitud — ' + (onboardingReview?.email || onboardingPartnerName)"
  [(visible)]="onboardingDialogVisible"
  [modal]="true"
  [style]="{ width: '920px', maxWidth: '96vw' }"
  (onHide)="closeOnboardingDialog()"
>
  <div *ngIf="onboardingLoading" class="review-loading">Cargando solicitud…</div>

  <div *ngIf="!onboardingLoading && onboardingReview" class="onboarding-review">

    <section class="review-section">
      <h6>Datos del solicitante</h6>
      <div class="applicant-grid">
        <div><span class="field-label">Nombre completo</span><span>{{ onboardingReview.firstName || '—' }} {{ onboardingReview.lastName || '' }}</span></div>
        <div><span class="field-label">Correo</span><span>{{ onboardingReview.email || '—' }}</span></div>
        <div><span class="field-label">WhatsApp</span><span>{{ onboardingReview.phone || '—' }}</span></div>
        <div><span class="field-label">Fecha de nacimiento</span><span>{{ onboardingReview.dateOfBirth || '—' }}</span></div>
        <div><span class="field-label">Edad</span><span>{{ formatAge(onboardingReview.age) }}</span></div>
        <div class="span-2"><span class="field-label">Dirección</span><span>{{ onboardingReview.address || '—' }}</span></div>
        <div><span class="field-label">Estado de la solicitud</span><span>{{ onboardingReview.overallStatusLabelEs || '—' }}</span></div>
        <div><span class="field-label">Fecha de envío</span><span>{{ submittedAtLabel() }}</span></div>
        <div><span class="field-label">Última actualización</span><span>{{ onboardingReview.lastUpdatedAt ? (onboardingReview.lastUpdatedAt | date:'medium') : '—' }}</span></div>
      </div>
      <p *ngIf="onboardingReview.onboarding?.accessDecisionReason">
        <strong>Motivo del estado:</strong> {{ onboardingReview.onboarding?.accessDecisionReason }}
      </p>
      <p *ngIf="onboardingReview.onboarding?.applicantRejectionExplanation">
        <strong>Explicación para el solicitante:</strong> {{ onboardingReview.onboarding?.applicantRejectionExplanation }}
      </p>
      <p *ngIf="activeCorrectionNote()" class="correction-banner">
        <strong>Nota de corrección:</strong> {{ onboardingReview.onboarding?.correctionMessage }}
      </p>
    </section>

    <section class="review-section">
      <h6>Elementos a revisar</h6>
      <p class="review-section-help">
        Revisa cada elemento, usa la vista previa en pantalla y aprueba o rechaza una sola vez.
        Eximir requisito no verifica un documento y no cambia el acceso del courier.
        La mayoría de edad exige la fecha de nacimiento enviada por el solicitante y no se exime.
      </p>
      <div class="review-item-list">
        <div class="review-item-card" *ngFor="let group of displayRequirementGroups()">
          <div class="review-item-header">
            <div>
              <div class="review-item-title">
                {{ isArtifactGroup(group) ? artifactCardTitle(group.requirementKey) : (group.labelEs || requirementLabel(group.requirementKey)) }}
              </div>
              <div class="review-item-meta" *ngIf="group.submittedAt || group.currentArtifact?.submittedAt || group.currentArtifact?.createdAt">
                Enviado:
                {{ (group.currentArtifact?.submittedAt || group.currentArtifact?.createdAt || group.submittedAt) | date:'medium' }}
                <span *ngIf="group.currentArtifact?.sizeBytes">
                  · {{ formatBytes(group.currentArtifact?.sizeBytes) }}
                </span>
              </div>
            </div>
            <span class="review-status-tag" [ngClass]="requirementTagClass(group)">
              {{ requirementTagLabel(group) }}
            </span>
          </div>

          <div *ngIf="isWaivedGroup(group)" class="waiver-panel">
            <p><strong>Motivo:</strong> {{ group.waiverReason || '—' }}</p>
            <p><strong>Autorizado por:</strong> {{ group.waivedBy || '—' }}</p>
            <p><strong>Fecha:</strong> {{ group.waivedAt ? (group.waivedAt | date:'medium') : '—' }}</p>
          </div>

          <p *ngIf="!isWaivedGroup(group) && (group.correctionReason || group.currentArtifact?.correctionReason)" class="correction-inline">
            <strong>Motivo:</strong> {{ group.correctionReason || group.currentArtifact?.correctionReason }}
          </p>

          <p *ngIf="isTermsGroup(group)" class="review-item-meta muted">
            Aceptado por el solicitante — no requiere revisión de admin.
          </p>

          <div *ngIf="isPersonalInfoGroup(group)" class="personal-info-summary">
            <span>{{ onboardingReview.firstName || '—' }} {{ onboardingReview.lastName || '' }}</span>
            <span>{{ onboardingReview.phone || '—' }}</span>
            <span>{{ onboardingReview.dateOfBirth || '—' }} · {{ formatAge(onboardingReview.age) }}</span>
            <span>{{ onboardingReview.address || '—' }}</span>
          </div>

          <ng-container *ngIf="isArtifactGroup(group)">
            <ng-container *ngIf="group.currentArtifact as artifact; else artifactMissing">
              <p *ngIf="artifact.videoChallengeWords" class="review-item-meta challenge-words">
                Palabras del reto: <strong>{{ artifact.videoChallengeWords }}</strong>
              </p>

              <div class="artifact-media">
                <div *ngIf="artifact.previewLoading" class="media-fallback">Cargando vista previa…</div>

                <button
                  *ngIf="!artifact.previewLoading && isImageArtifact(artifact) && previewAvailable(artifact)"
                  type="button"
                  class="artifact-preview-button"
                  (click)="openLightbox(artifact, $event)"
                  title="Ver en pantalla completa"
                >
                  <img [src]="trustPreviewUrl(artifact.previewUrl)" alt="Vista previa" class="artifact-preview"
                       (error)="onArtifactPreviewError(artifact)" />
                  <span class="artifact-preview-hint">Clic para ampliar</span>
                </button>

                <div
                  *ngIf="!artifact.previewLoading && isVideoArtifact(artifact) && previewAvailable(artifact)"
                  class="artifact-preview-video-wrap"
                >
                  <video
                    [src]="trustPreviewUrl(artifact.previewUrl)"
                    controls
                    playsinline
                    preload="metadata"
                    class="artifact-preview artifact-preview-video"
                    (error)="onArtifactPreviewError(artifact)"
                  ></video>
                  <button
                    pButton
                    type="button"
                    class="p-button-sm p-button-outlined artifact-expand-btn"
                    label="Pantalla completa"
                    icon="pi pi-window-maximize"
                    (click)="openLightbox(artifact, $event)"
                  ></button>
                </div>

                <div *ngIf="!artifact.contentAvailable" class="media-fallback muted">Archivo no disponible.</div>

                <div *ngIf="artifact.contentAvailable && !artifact.previewLoading && previewFailed(artifact)" class="media-fallback">
                  <p *ngIf="isVideoArtifact(artifact)">No se pudo reproducir el video en la página.</p>
                  <p *ngIf="isImageArtifact(artifact)">No se pudo mostrar la imagen en la página.</p>
                  <p *ngIf="!isImageArtifact(artifact) && !isVideoArtifact(artifact)">
                    No se pudo mostrar la vista previa (tipo: {{ artifact.mimeType || 'desconocido' }}).
                  </p>
                  <p *ngIf="artifact.previewError" class="preview-error-detail">{{ artifact.previewError }}</p>
                  <div class="media-fallback-actions">
                    <button pButton type="button" class="p-button-sm p-button-outlined"
                            label="Reintentar vista previa"
                            (click)="retryArtifactPreview(artifact)"></button>
                    <button pButton type="button" class="p-button-sm p-button-secondary"
                            label="Descargar"
                            (click)="downloadArtifact(artifact)"></button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #artifactMissing>
              <div class="media-fallback muted">No hay archivo cargado todavía.</div>
            </ng-template>
          </ng-container>

          <div class="review-item-actions">
            <button pButton type="button" label="Aprobar" class="p-button-sm p-button-success"
                    *ngIf="showReviewActions(group)"
                    [disabled]="isReviewBusy('step:PERSONAL_INFO') || isReviewBusy('artifact:' + group.requirementKey)"
                    (click)="isPersonalInfoGroup(group) ? approvePersonalInfo(group) : approveArtifact(group)"></button>
            <button pButton type="button" label="Rechazar" class="p-button-sm p-button-danger p-button-outlined"
                    *ngIf="showReviewActions(group)"
                    [disabled]="isReviewBusy('step:PERSONAL_INFO') || isReviewBusy('artifact:' + group.requirementKey)"
                    (click)="isPersonalInfoGroup(group) ? openRejectPersonalInfo(group) : openRejectArtifact(group)"></button>
            <button pButton type="button" label="Descargar" class="p-button-sm p-button-secondary"
                    *ngIf="group.currentArtifact?.contentAvailable"
                    (click)="downloadArtifact(group.currentArtifact!)"></button>
            <button pButton type="button" label="Eximir requisito" class="p-button-sm p-button-warning p-button-outlined"
                    *ngIf="canWaiveGroup(group)"
                    [disabled]="isReviewBusy('waiver:' + group.requirementKey)"
                    (click)="openWaiverDialog(group, 'WAIVE')"></button>
            <button pButton type="button" label="Revocar exención" class="p-button-sm p-button-secondary p-button-outlined"
                    *ngIf="isWaivedGroup(group)"
                    [disabled]="isReviewBusy('waiver:' + group.requirementKey)"
                    (click)="openWaiverDialog(group, 'REVOKE')"></button>
          </div>

          <div *ngIf="group.historyArtifacts?.length" class="history-block">
            <button type="button" class="history-toggle" (click)="toggleHistory(group.requirementKey)">
              Historial ({{ group.historyArtifacts?.length }})
            </button>

            <div *ngIf="isHistoryExpanded(group.requirementKey)" class="history-list">
              <div class="history-item" *ngFor="let history of visibleHistoryArtifacts(group)">
                <div class="history-item-header">
                  <span class="review-status-tag" [ngClass]="reviewStatusClass(history.reviewStatusLabelEs || history.reviewStatus)">
                    {{ history.reviewStatusLabelEs || history.reviewStatus || '—' }}
                  </span>
                  <span class="review-item-meta">{{ (history.submittedAt || history.createdAt) | date:'medium' }}</span>
                </div>
                <p *ngIf="history.correctionReason" class="correction-inline">{{ history.correctionReason }}</p>
                <button pButton type="button" label="Descargar" class="p-button-sm p-button-text"
                        *ngIf="history.contentAvailable"
                        (click)="downloadArtifact(history)"></button>
              </div>
              <button *ngIf="hiddenHistoryCount(group) > 0" type="button" class="history-more"
                      (click)="showAllHistory(group.requirementKey)">
                Ver más ({{ hiddenHistoryCount(group) }})
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div *ngIf="!canApproveApplicant()" class="approval-gate">
      <strong>No puedes aprobar esta solicitud todavía.</strong>
      <p>Falta aprobar: {{ missingApprovalsLabel() }}</p>
    </div>
  </div>

  <div *ngIf="!onboardingLoading && !onboardingReview">No onboarding record yet.</div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cerrar" class="p-button-text" (click)="closeOnboardingDialog()"></button>
    <button pButton type="button" [label]="approveFooterLabel()" class="p-button-success"
            *ngIf="selectedPartner && selectedPartner.status !== 'APPROVED'"
            [disabled]="!canSubmitApproveFooter()"
            (click)="confirmApproveApplicant()"></button>
    <button pButton type="button" label="Shortlist" class="p-button-info"
            *ngIf="selectedPartner && selectedPartner.status !== 'SHORTLISTED'"
            (click)="confirmShortlist(selectedPartner!)"></button>
    <button pButton type="button" label="Rechazar solicitud" class="p-button-danger"
            *ngIf="selectedPartner"
            (click)="confirmSetStatus(selectedPartner!, 'REJECTED')"></button>
    <button pButton type="button" label="Volver a solicitante" class="p-button-outlined"
            *ngIf="selectedPartner?.status === 'REJECTED'"
            (click)="openApplicantReturn(selectedPartner!)"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Rechazar solicitud" [(visible)]="applicationRejectVisible" [modal]="true"
          [style]="{ width: '560px', maxWidth: '95vw' }">
  <p class="reject-intro">La explicación para el solicitante se muestra en la app. La nota interna no se muestra.</p>
  <label class="field-label" for="applicantExplanation">Explicación para el solicitante</label>
  <textarea id="applicantExplanation" pInputTextarea rows="4" class="reject-reason-input"
            [(ngModel)]="applicantExplanation"
            placeholder="Opcional. Si la dejas vacía, la app muestra el mensaje general."></textarea>
  <label class="field-label" for="internalRejectionNote">Nota interna</label>
  <textarea id="internalRejectionNote" pInputTextarea rows="3" class="reject-reason-input"
            [(ngModel)]="internalRejectionNote"
            placeholder="Opcional. Solo la ve el equipo de operaciones."></textarea>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text"
            (click)="applicationRejectVisible = false"></button>
    <button pButton type="button" label="Rechazar solicitud" class="p-button-danger"
            [disabled]="statusUpdating"
            (click)="submitApplicationReject()"></button>
  </ng-template>
</p-dialog>

<p-dialog [header]="rejectDialogTitle()" [(visible)]="rejectDialogVisible" [modal]="true"
          [style]="{ width: '520px', maxWidth: '95vw' }">
  <p class="reject-intro">Indica el motivo del rechazo. El solicitante verá este mensaje.</p>

  <div class="quick-reasons">
    <button type="button" class="reason-chip"
            *ngFor="let reason of quickReasonsFor(rejectTarget)"
            [class.reason-chip-active]="rejectReason === reason"
            (click)="selectQuickReason(reason)">
      {{ reason }}
    </button>
  </div>

  <textarea pInputTextarea rows="4" class="reject-reason-input"
            [(ngModel)]="rejectReason"
            placeholder="Motivo del rechazo"></textarea>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text"
            (click)="rejectDialogVisible = false"></button>
    <button pButton type="button" [label]="rejectSubmitLabel()" class="p-button-danger"
            [disabled]="rejectSubmitting || !rejectReason.trim()"
            (click)="submitReject()"></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="lightboxVisible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '96vw', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0.75rem' }"
  styleClass="artifact-lightbox-dialog"
  [header]="lightboxArtifact?.originalFilename || 'Vista previa'"
  (onHide)="closeLightbox()"
>
  <ng-container *ngIf="lightboxArtifact as media">
    <img
      *ngIf="isImageArtifact(media) && media.previewUrl"
      [src]="trustPreviewUrl(media.previewUrl)"
      alt="Vista ampliada"
      class="artifact-lightbox-media"
    />
    <video
      *ngIf="isVideoArtifact(media) && media.previewUrl"
      [src]="trustPreviewUrl(media.previewUrl)"
      controls
      playsinline
      autoplay
      class="artifact-lightbox-media artifact-lightbox-video"
    ></video>
  </ng-container>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Abrir en pestaña"
            icon="pi pi-external-link"
            (click)="openLightboxInNewTab()"></button>
    <button pButton type="button" class="p-button-text" label="Cerrar"
            (click)="closeLightbox()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<p-dialog [header]="waiverAction === 'WAIVE' ? 'Eximir requisito' : 'Revocar exención'"
          [(visible)]="waiverDialogVisible" [modal]="true"
          [style]="{ width: '520px', maxWidth: '95vw' }">
  <p *ngIf="waiverAction === 'WAIVE'">
    Esto exime el requisito. No aprueba un documento y no cambia el acceso del courier.
  </p>
  <p *ngIf="waiverAction === 'REVOKE'">
    La exención deja de contar para el checklist. El documento, si existe, permanece como estaba.
  </p>
  <label for="waiverReason">Motivo</label>
  <textarea id="waiverReason" pInputTextarea [(ngModel)]="waiverReason" rows="4" class="w-full"
            placeholder="Por qué se exime o se revoca este requisito"></textarea>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text"
            (click)="waiverDialogVisible = false"></button>
    <button pButton type="button" [label]="waiverAction === 'WAIVE' ? 'Eximir requisito' : 'Revocar exención'"
            [disabled]="!waiverReason.trim()"
            (click)="submitRequirementWaiver()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Volver a solicitante" [(visible)]="applicantReturnVisible" [modal]="true"
          [style]="{ width: '520px', maxWidth: '95vw' }">
  <p>Esto devuelve el acceso a solicitante. No crea una solicitud de corrección. La nota queda solo para operaciones.</p>
  <label for="applicantReturnReason">Nota interna</label>
  <textarea id="applicantReturnReason" pInputTextarea [(ngModel)]="applicantReturnReason" rows="4" class="w-full"
            placeholder="Opcional. No se muestra en la app."></textarea>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text"
            (click)="applicantReturnVisible = false"></button>
    <button pButton type="button" label="Volver a solicitante"
            [disabled]="statusUpdating"
            (click)="submitApplicantReturn()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Restrict to shortlisted" [(visible)]="demotionDialogVisible" [modal]="true"
          [style]="{ width: '520px', maxWidth: '95vw' }">
  <p>This removes open-network access. Paired hubs, accepted deliveries, and picked-up deliveries stay in place. Missing documents are not created.</p>
  <label for="demotionReason">Reason</label>
  <textarea id="demotionReason" pInputTextarea [(ngModel)]="demotionReason" rows="4" class="w-full"
            placeholder="Why this approved courier is being restricted"></textarea>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" class="p-button-text"
            (click)="demotionDialogVisible = false"></button>
    <button pButton type="button" label="Restrict to shortlisted"
            [disabled]="!demotionReason.trim()"
            (click)="submitApprovedDemotion()"></button>
  </ng-template>
</p-dialog>


<p-dialog
  [header]="'Courier reviews — ' + reviewsPartnerName"
  [(visible)]="reviewsDialogVisible"
  [modal]="true"
  [style]="{ width: '720px', maxWidth: '96vw' }"
>
  <div *ngIf="reviewsLoading">Loading reviews…</div>
  <ng-container *ngIf="!reviewsLoading && courierReviewProfile as profile">
    <p><strong>Average:</strong> {{ formatAverageRating(profile.averageRating) }}
      ({{ profile.reviewCount || 0 }} reviews)</p>
    <div *ngIf="!(profile.reviews && profile.reviews.length)">No hub reviews yet.</div>
    <div *ngFor="let r of profile.reviews" style="border-top:1px solid #e5e7eb;padding:0.75rem 0;">
      <div><strong>{{ r.hubName || r.hubId || 'Hub' }}</strong> — {{ r.stars }}/5</div>
      <div *ngIf="r.comment">{{ r.comment }}</div>
      <div *ngIf="r.createdAt" style="opacity:0.7;font-size:0.85rem">{{ r.createdAt | date:'short' }}</div>
    </div>
  </ng-container>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Close" (click)="reviewsDialogVisible = false"></button>
  </ng-template>
</p-dialog>
